import Vue from "vue";

class commaIntClass {

    fn(value, num) {

        if (_.trim(value) == '') value = '0';
        if (typeof value == 'string') value = value.replace(/,/g, '');

        let decimalLen = _.isNil(num) || num < 0 ? 2 : num;

        if (_.isNaN(parseInt(value))) value = '0';
            
        //return _.round(Number(value), decimalLen).toLocaleString('en-US', { minimumFractionDigits: decimalLen });
        return Number(value).toLocaleString('en-US');
    }

    init() {
        let self = this;

        Vue.filter('commaInt', function (value, num) {
            return self.fn(value, _.isNil(num) || num < 0 ? 2 : num);
        });

        Vue.directive('commaInt', {
            bind: function (el, binding) {

                var handler = function () {
                    if (el.value != el.oldValue) {

                        let num = 0;
                        el.value = self.fn(el.value, num);

                        var event = document.createEvent('Event');
                        event.initEvent('input', true, true);
                        el.dispatchEvent(event);

                    }
                };
                el.commaHandler = handler;
                el.addEventListener('change', handler);

                handler();
            }
        });
    }
}
new commaIntClass().init();



// WEBPACK FOOTER //
// ./src/helpers/comma-int.js